import { Box, Skeleton } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const TableSkeleton = () => {
  // Create skeleton rows for the table
  const skeletonRows = Array.from({ length: 10 }, (_, index) => ({
    id: index,
    orderNo: <Skeleton variant="text" width={80} />,
    dateTime: <Skeleton variant="text" width={120} />,
    customerName: <Skeleton variant="text" width={100} />,
    amount: <Skeleton variant="text" width={70} />,
    paymentMethod: <Skeleton variant="text" width={90} />,
    paymentStatus: (
      <Box
        sx={{
          width: 78,
          height: 24,
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton
          variant="rectangular"
          width={78}
          height={24}
          sx={{ borderRadius: '6px' }}
        />
      </Box>
    ),
    orderStatus: (
      <Box
        sx={{
          width: 100,
          height: 24,
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton
          variant="rectangular"
          width={100}
          height={24}
          sx={{ borderRadius: '6px' }}
        />
      </Box>
    ),
    action: <Skeleton variant="circular" width={22} height={22} />,
  }));

  // Define columns to match the actual table
  const columns: GridColDef[] = [
    {
      field: 'orderNo',
      headerName: 'Order Number',
      width: 150,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'dateTime',
      headerName: 'Date & Time',
      width: 180,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'customerName',
      headerName: 'Customer Name',
      width: 150,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 120,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'paymentMethod',
      headerName: 'Payment Method',
      width: 150,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'paymentStatus',
      headerName: 'Payment Status',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'orderStatus',
      headerName: 'Order Status',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      sortable: false,
      headerClassName: 'custom-header',
      renderCell: params => params.value,
    },
  ];

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={skeletonRows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        pageSizeOptions={[10, 20, 50, 75, 100]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        sx={{
          borderRadius: '8px',
          color: 'rgba(107, 111, 128, 1)',
          '& .MuiDataGrid-root': {
            borderRadius: '8px',
            overflow: 'hidden',
          },
          '& .MuiDataGrid-main': {
            borderRadius: '8px',
            overflow: 'hidden',
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
          },
          '& .MuiDataGrid-columnHeader': {
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
          },
          '& .custom-header': {
            bgcolor: '#F8F9FC',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
            padding: '12px 16px',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: 'rgba(43, 45, 63, 1)',
            fontWeight: 600,
          },
        }}
      />
    </Box>
  );
};

export default TableSkeleton;
